import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VilleService {

  constructor(private http:HttpClient) { }
  fetchalllvilles(){
    let url = (`${environment.apiUrl}/Ville/getVilles`);
    return this.http.get<any>(url);
  }
  getvillename(idville:any){
    return this.http.get<any>(`${environment.apiUrl}/Ville/getname/${idville}`)
  }
  Getlistvilleforstudent(limit:number){
    return this.http.get<any>(`${environment.apiUrl}/StudentCity/${limit}`)

  }
  GetVillebyname(name:string){
    return this.http.get<any>(`${environment.apiUrl}/StudentCity/getByName/${name}`)

  }
  searchVilleForstudent(term:any){
    return this.http.post<any>(`${environment.apiUrl}/StudentCity/searchCity`,term)
  }
  
}
